import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton, MessageBar, MessageBarType, Spinner, SpinnerSize } from 'office-ui-fabric-react';
import { useMutation } from 'multi-apollo';
import gql from 'graphql-tag';


const CREATE_SOCIAL_PAYLOAD_FROM_WORD = gql`
  mutation CreateSocialPayloadFromWord($wordId: Int!) {
    createSocialPayloadFromWord(wordId: $wordId) {
      id
    }
  }
`;


export function ToolsTab(props: { word: { id: number } }) {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [createPayload, { loading }] = useMutation(CREATE_SOCIAL_PAYLOAD_FROM_WORD);

  const handleCreate = useCallback(async () => {
    setError(null);
    try {
      const result = await createPayload({
        variables: { wordId: props.word.id },
      });
      const payloadId = result.data.createSocialPayloadFromWord.id;
      navigate(`/social/${payloadId}`);
    } catch (err: any) {
      setError(err.message || 'Failed to create social payload');
    }
  }, [props.word.id, createPayload, navigate]);

  return (
    <div style={{ padding: '20px 0' }}>
      <h3 style={{ marginTop: 0 }}>Social Media</h3>
      <p style={{ color: '#666', marginBottom: 16 }}>
        Create a social media payload from this dictionary entry. The word text, diacritics,
        translation, transliteration, and audio recording will be copied over.
      </p>

      {error && (
        <MessageBar messageBarType={MessageBarType.error} style={{ marginBottom: 16 }}>
          {error}
        </MessageBar>
      )}

      <PrimaryButton
        text={loading ? 'Creating...' : 'Create Social Payload'}
        iconProps={{ iconName: 'Share' }}
        onClick={handleCreate}
        disabled={loading}
      />
      {loading && <Spinner size={SpinnerSize.small} style={{ display: 'inline-block', marginLeft: 12 }} />}
    </div>
  );
}
